import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";

export default function Datenschutz() {
  return (
    <div className="container py-5" style={{ maxWidth: "900px" }}>
      <h1 className="mb-4">Datenschutzerklärung</h1>

      <p>
        Der Schutz Ihrer personenbezogenen Daten hat für die Fahrlux Hanau
        höchste Priorität. Nachfolgend informieren wir Sie gemäß der
        Datenschutz-Grundverordnung (DSGVO) über Art, Umfang und Zweck der
        Verarbeitung personenbezogener Daten auf unserer Website.
      </p>

      <h2>1. Verantwortlicher</h2>
      <p>
        Fahrlux Hanau
        <br />
        E-Mail: info@fahrlux-hanau.de
      </p>

      <h2>2. Allgemeine Datenverarbeitung</h2>
      <p>
        Wir verarbeiten personenbezogene Daten ausschließlich im Rahmen der
        gesetzlichen Bestimmungen. Eine Nutzung unserer Website ist
        grundsätzlich ohne Angabe personenbezogener Daten möglich.
      </p>

      <h2>3. Server-Logfiles</h2>
      <p>
        Beim Besuch unserer Website erhebt und speichert der Provider
        automatisch Informationen in sogenannten Server-Logfiles. Diese Daten
        umfassen z. B. Browsertyp, Betriebssystem, Referrer-URL, IP-Adresse und
        Uhrzeit des Zugriffs. Diese Daten sind nicht bestimmten Personen
        zuordenbar.
      </p>

      <h2>4. Kontaktaufnahme</h2>
      <p>
        Wenn Sie uns per E-Mail oder Kontaktformular kontaktieren, werden Ihre
        Angaben zur Bearbeitung der Anfrage und für mögliche Anschlussfragen
        gespeichert. Diese Daten geben wir nicht ohne Ihre Einwilligung weiter.
      </p>

      <h2>5. Buchungs- und Fahrdaten</h2>
      <p>
        Im Rahmen von Buchungen verarbeiten wir notwendige Daten wie Name,
        Telefonnummer, Abhol- und Zieladresse sowie Fahrtzeit zur Durchführung
        unserer Dienstleistung.
      </p>

      <h2>6. Cookies</h2>
      <p>
        Unsere Website kann Cookies verwenden, um die Benutzerfreundlichkeit zu
        verbessern. Sie können die Speicherung von Cookies jederzeit in Ihrem
        Browser deaktivieren.
      </p>

      <h2>7. Analyse-Tools</h2>
      <p>
        Wir verwenden derzeit keine Tracking- oder Analyse-Tools (z. B. Google
        Analytics).
      </p>

      <h2>8. SSL-/TLS-Verschlüsselung</h2>
      <p>
        Diese Website nutzt aus Sicherheitsgründen eine
        SSL-/TLS-Verschlüsselung. Dadurch werden übertragene Daten geschützt.
      </p>

      <h2>9. Rechtsgrundlagen</h2>
      <p>
        Die Verarbeitung personenbezogener Daten erfolgt gemäß Art. 6 DSGVO,
        insbesondere zur Vertragserfüllung, auf Basis Ihrer Einwilligung oder
        berechtigter Interessen.
      </p>

      <h2>10. Ihre Rechte</h2>
      <ul>
        <li>Auskunft über gespeicherte Daten</li>
        <li>Berichtigung unrichtiger Daten</li>
        <li>Löschung Ihrer Daten</li>
        <li>Einschränkung der Verarbeitung</li>
        <li>Widerspruch gegen Verarbeitung</li>
        <li>Datenübertragbarkeit</li>
      </ul>

      <h2>11. Widerspruchsrecht</h2>
      <p>
        Sie haben das Recht, der Verarbeitung Ihrer personenbezogenen Daten
        jederzeit zu widersprechen.
      </p>

      <h2>12. Änderungen dieser Datenschutzerklärung</h2>
      <p>
        Wir behalten uns vor, diese Datenschutzerklärung bei Bedarf anzupassen,
        um sie aktuellen rechtlichen Anforderungen zu entsprechen.
      </p>

      <p className="mt-4 text-muted">Stand: April 2026</p>
    </div>
  );
}
